import { styled } from '@mui/material/styles';
import { ReactComponent as OldLogo } from './oldLogo.svg';
import { ReactComponent as NewLogo } from './newLogo.svg';

export const LogoSVG = styled(NewLogo)(({ theme }) => ({
  color: theme.color.primary.main,
  height: '4em',
  padding: '8px'
}));

export const OldLogoSVG = styled(OldLogo)(({ theme, size }) => ({
  color: theme.color.primary.contrast,
  ...(size === 'large' && {
    fontSize: '38px !important',
    marginLeft: '5%',
    marginTop: '5%'
  })
}));
